import { connect } from "react-redux";
import GenericItemsView, { type GenericItemsViewProps } from "../../../../../../../../views/ItemsView/GenericItemsView";
import { type AppDispatch, type RootState } from "../../../../../../../Application/globaltypes/redux";
import { type SurveyGroup } from "../../../../../types/models";
import { selectedItemsChanged } from "../../../../../state/slices/surveyGroupsSlice";
import { surveysStateSelector } from "../../../../../state/surveyReducer";

const mapStateToProps = (state: RootState) => {
  const edit = surveysStateSelector(state).edit;
  return {
    items: edit.groups.items,
    isLoading: edit.groups.isLoading,
    dataCount: edit.groups.itemsCount,
    selectedIds: edit.groups.selectedIds,
  };
};

/* istanbul ignore next */
const mapDispatchToProps = (dispatch: AppDispatch) => ({
  onSelectedItemChanged: (ids: number[]) => dispatch(selectedItemsChanged(ids)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GenericItemsView as (props: GenericItemsViewProps<SurveyGroup>) => React.ReactElement);
